const opt = (value, label) => ({ value, label });

export const CITIZENSHIP = [
    opt('0', 'US Citizen'),
    opt('1', 'Permanent Resident Alien'),
    opt('2', 'Non-permanent Resident Alien'),
    opt('3', 'Foreign National'),
    opt('4', 'ITIN'),
];

export const INCOME_TYPE = [
    // Documented income (non-ITIN)
    opt('900', 'W2'),
    opt('9018', 'Tax Returns'),
    opt('9014', 'Retirement'),
    opt('9015', 'Bank Statements'),
    opt('9015S12M', 'Bank Statement - Standard 12 months'),
    opt('9015S24M', 'Bank Statement - Standard 24 months'),
    opt('9015SL', 'Bank Statements - Streamline'),
    opt('9017', 'P&L'),
    opt('9017BS', 'P&L + Bank Statements'),
    opt('9022', 'WVOE'),
    opt('9013', '1099'),
    opt('9019', 'Asset Utilization'),
    // Documented income (ITIN)
    opt('0', 'W2'),
    opt('22', 'WVOE'),
    opt('15', 'Bank Statements'),
    opt('15S12M', 'Bank Statement - Standard 12 months'),
    opt('15S24M', 'Bank Statement - Standard 24 months'),
    opt('15SL', 'Bank Statements - Streamline'),
    opt('17', 'P&L'),
    opt('17BS', 'P&L + Bank Statements'),
    opt('18', '1 Year Tax Return'),
    opt('13', '1099'),
    opt('19', 'Asset Utilization'),
    // No-ratio and DSCR
    opt('20', 'DSCR'),
    opt('21', 'No Income/Employment/DTI'),
    opt('6030', 'Foreign Income'),
    opt('700', 'DSCR >= 1.25'),
    opt('701', 'DSCR 1.0 - 1.24'),
    opt('702', 'DSCR 0.75 - 0.99'),
    opt('703', 'DSCR < 0.75 (No Ratio)'),
    opt('800', 'DSCR 1.0+'),
    opt('801', 'DSCR 0.90 - 0.99'),
    opt('802', 'DSCR 0.80 - 0.899'),
];

export const INCOME_TYPES_STANDARD = [
    '900', '9018', '9014', '9015S12M', '9015S24M', '9015SL', '9017', '9017BS', '9022', '9013', '9019',
    '21',
    '700', '701', '702', '703',
];

export const INCOME_TYPES_CORRESPONDENT = INCOME_TYPES_STANDARD.filter((v) => v !== '21');
export const INCOME_TYPE_FOREIGN = '6030';

export const INCOME_TYPES_ITIN = [
    '0', '22', '15S12M', '15S124M', '15SL', '17', '17BS', '18', '13', '19', '21',
    '800', '801', '802',
];

export const OCCUPANCY = [
    opt('0', 'Primary Residence'),
    opt('1', 'Secondary Residence'),
    opt('2', 'Investment'),
];

export const PURPOSE = [
    opt('0', 'Purchase'),
    opt('1', 'Refi Rate/Term'),
    opt('2', 'Refinance Cashout'),
    opt('3', 'Debt Consolidation'),
];

export const LOCK_PERIOD = [opt('30', '30 Days')];
export const LOCK_PERIOD_CORRESPONDENT = [opt('30', '30 Days'), opt('45', '45 Days')];

export const AMORTIZATION_TYPE = [
    opt('1', '15 Year Fixed'),
    opt('2', '30 Year Fixed'),
    opt('4', '5/6 ARM'),
    opt('5', '7/6 ARM'),
    opt('6', '10/6 ARM'),
];

export const AMORTIZATION_MAP = {
    1: { term: ['180'], amortInHero: ['Fixed'], fixedTerm: [] },
    2: { term: ['360'], amortInHero: ['Fixed'], fixedTerm: [] },
    3: { term: ['480'], amortInHero: ['Fixed'], fixedTerm: [] },
    4: { term: ['360'], amortInHero: ['ARM'], fixedTerm: ['60'] },
    5: { term: ['360'], amortInHero: ['ARM'], fixedTerm: ['84'] },
    6: { term: ['360'], amortInHero: ['ARM'], fixedTerm: ['120'] },
};

export const BANK_STATEMENT_MONTHS = [opt('12', '12 Months'), opt('24', '24 Months')];

export const CLOSING_ENTITY = [
    opt('1', 'LLC'),
    opt('2', 'S-Corp/C-Corp'),
    opt('3', 'Natural Person'),
];

export const PRE_ASSET_DEPLETION = [opt('0.75-0.99', '0.75 - 0.99'), opt('<0.75', '< 0.75')];

export const PROPERTY_TYPE = [
    opt('0', 'SFR'),
    opt('MU', 'Multi-Unit'),
    opt('1', 'PUD'),
    opt('2', 'Condo'),
    opt('4S', 'Non-Warrantable Condo'),
    opt('4D', 'Condotel'),
];

export const UNITS = [1, 2, 3, 4, 5, 6, 7, 8].map((n) =>
    opt(String(n), `${n} Unit${n === 1 ? '' : 's'}`),
);

export const UNITS_TO_PROPERTY_TYPE = { 2: '8', 3: '9', 4: '10', 5: '11', 6: '11', 7: '11', 8: '11' };

export const BROKER_COMPENSATION = [opt('1', 'BPC'), opt('2', 'LPC')];

export const DTI = [
    opt('20', '<= 43%'),
    opt('44', '> 43% - 45%'),
    opt('46', '> 45% - 50%'),
    opt('55', '> 50%'),
    opt('51', '> 50% - 55%'),
    opt('56', '> 55%'),
    opt('38', '<= 38%'),
    opt('39', '> 38%'),
];

export const DTI_NO_RATIO = opt('0', 'No Ratio');

export const PPP_TERM = [
    opt('5', '5 Year 5% fixed'),
    opt('6', '5 Year 5, 4, 3, 2, 1'),
    opt('4', '4 Year 5% fixed'),
    opt('8', '4 Year 5, 4, 3, 2'),
    opt('3', '3 Year 5% fixed'),
    opt('7', '3 Year 5, 4, 3'),
    opt('2', '2 Year 5% fixed'),
    opt('9', '2 Year 5, 4'),
    opt('1', '1 Year 5% fixed'),
    opt('10', '6 Month 5% fixed'),
    opt('0', 'No'),
];

export const HOUSING_EVENT = [
    opt('1', 'N/A'),
    opt('5', '>=48 Months'),
    opt('2', '>=36 Months'),
    opt('3', '>=24 Months'),
    opt('4', '>=12 Months'),
];

export const CREDIT_SEASONING = [
    opt('1', 'N/A'),
    opt('5', '0x30x24'),
    opt('2', '1x30x12'),
    opt('3', '0x60x12'),
    opt('4', '0x90x12'),
];

export const LIEN_POSITION = [
    opt('1', 'First'),
    opt('2', 'Second'),
];

export const YSP_NA = [opt('0.000', 'N/A')];

export const MAX_PRICE_BY_TYPE = {
    6: 102, 601: 102, 602: 102,
    7: 103, 750: 103, 758: 100,
    8: 99.25,
    9: 101.5, 901: 101.5,
    12: 101.5,
    13: 102,
    14: 100,
    16: 0,
};

export const findLabel = (list, value) => list.find((o) => o.value === value)?.label ?? '';
